/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { IUrjanetMessageObjectType } from './types';
import descriptors from '../../../locales/en-US/descriptors';
import { IXLSXFileUploadSettings } from './EquipmentSpaceMappingAndProperties/FileReaderUtils/FileValidator';

export const UtilityMeterField = {
  totalActualConsumption: 'totalActualConsumption',
  type: 'type',
  previousPeriodConsumption: 'previousPeriodConsumption',
  percentageConsumptionSaving: 'percentageConsumptionSaving',
  consumptionSavings: 'consumptionSavings',
  totalActualCost: 'totalActualCost',
  previousPeriodCost: 'previousPeriodCost',
  percentageCostSavings: 'percentageCostSavings',
  costSavings: 'costSavings',
  siteName: 'siteName'
};

export const ListOfMeterDetails = {
  Meters: 'meterName',
  ActivePower: 'ActivePower',
  AVGpower: 'avgPowerOfActivePower',
  PeakPower: 'maxPowerOfActivePower',
  LoadType: 'LoadType',
  EnergyConsToday: 'EnergyConsToday',
  EnergyConsMonth: 'EnergyConsMonth',
  TotalEnergyConsumption: 'TotalEnergyConsumption',
  DataQuality: 'DataQuality',
  BaselineQuality: 'BaselineQuality',
  ElectricityConsumption: 'electricityConsumption',
  EnergyConsSelectedPeriod: 'EnergyConsSelectedPeriod',
  FifteenminutedElectricityActual: 'FifteenminutedElectricityActual',
  FifteenMinutesBaseline: 'FifteenMinutesBaseline',
  Realpower: 'Realpower',
  PowerDemand: 'PowerDemand',
  FifteenMinuteElectricConsumption: 'FifteenMinuteElectricConsumption',
  FifteenMinuteElectricConsumptionPrediction:
    'FifteenMinuteElectricConsumptionPrediction',
  change: 'rawTotalDeviation',
  eqdetails: 'eqDetails'
};

export const UtilityDetailMeterField = {
  totalActualConsumption: 'totalActualConsumption',
  Meter: 'meter',
  previousPeriodConsumption: 'previousPeriodConsumption',
  percentageConsumptionSaving: 'percentageConsumptionSaving',
  totalConsumptionSavings: 'totalConsumptionSavings',
  totalActualCost: 'totalActualCost',
  previousPeriodCost: 'previousPeriodCost',
  percentageCostSavings: 'percentageCostSavings',
  totalCostSavings: 'totalCostSavings',
  siteName: 'siteName'
};

export const CarbonDetailSiteField = {
  site: 'site',
  actualConsumption: 'actualConsumption',
  baselineConsumption: 'baselineConsumption',
  change: 'change'
};

export const CarbonDetailMeterField = {
  meter: 'meter',
  utilityType: 'type',
  actualConsumption: 'actualConsumption',
  baselineConsumption: 'baselineConsumption',
  change: 'change',
  fuelTypeName: 'fuelTypeName',
  combustionType: 'combustionType',
  scope: 'scope',
  scope1: 'Scope1'
};

export const CarbonScopeDetailsField = {
  meter: 'meter',
  utilityType: 'type',
  actualConsumption: 'actualConsumption',
  baselineConsumption: 'baselineConsumption',
  change: 'change',
  scope: 'scope',
  fuelTypeName: 'fuelTypeName',
  combustionType: 'combustionType'
};

export const EnergyDetailMeterField = {
  meter: 'meter',
  utilityType: 'type',
  actualConsumption: 'rawActualConsumption',
  baselineConsumption: 'rawBaselineConsumption',
  change: 'rawChange'
};
export const CarbonDetailExpandMeterField = {
  meter: 'utilityType',
  utilityType: 'type',
  actualConsumption: 'totalActualEmission',
  baselineConsumption: 'totalPreviousPeriodEmission',
  change: 'totalDeviation'
};

export const EnergyUsagesDetailExpandMeterField = {
  meter: 'utilityType',
  utilityType: 'type',
  actualConsumption: 'rawTotalActualEmission',
  baselineConsumption: 'rawTotalPreviousPeriodEmission',
  change: 'rawTotalDeviation',
  eqdetails: 'eqDetails'
};

export const CarbonMeterField = {
  totalEmissionSavingsPercentage: 'totalEmissionSavingsPercentage',
  utilityType: 'utilityType',
  totalBaselineEmission: 'totalBaselineEmission',
  totalActualEmission: 'totalActualEmission',
  meterName: 'meterName',
  BaselineCost: 'baselineCost',
  PercentageCostSavings: 'percentageCostSavings'
};

export const DetailViewRoutes = {
  carbonDetailView: 'carbondetail',
  energyDetailView: 'energydetail',
  waterDetailView: 'waterdetail',
  UtilityCost: 'utilitycost',
  UtilityBillView: 'utilitybilldetail',
  SiteDetailView: 'sitedetail',
  EmaasEnergyUsage: 'emaasenergyusage'
};

export const MeterListViewRoutes = {
  meterPerformace: 'meterperformace'
};

export const UtilityType = {
  Gas: 'Gas',
  Electricity: 'Electricity',
  Water: 'Water',
  Energy: 'Energy',
  All: 'all',
  CO2: 'CO2',
  Sewerage: 'Sewerage',
  Electric: 'electric',
  Sewer: 'Sewer',
  ElectricCaps: 'Electric'
};

export const EnergyUsageUtilityType = {
  Gas: 'gas',
  Electricity: 'electricity',
  Water: 'water'
};

export const EnergyUsageScopeType = {
  Gas: 'gas',
  ELECTRIC: 'electric',
  ELECTRICITY: 'Electricity',
  ALL: 'all',
  WATER: 'water',
  ENERGYDISAGGREGATION: 'energydisaggregation'
};

export const ConfigureAddService = {
  AddService: 'addservice',
  UtilityService: 'utilityservice',
  WeatherConfigure: 'WeatherConfigure',
  settings: 'configuration'
};

export enum UtilityIndex {
  All,
  Electricity,
  Gas
}

export enum TabIndex {
  ZERO,
  ONE,
  TWO
}

export const VerticalTab = {
  SiteSettings: 'Site Settings',
  ServicesIntegrations: 'Services',
  UserManagement: 'User Management',
  GeneralSettings: 'General Settings'
};

export interface IManualFileUploadType {
  type: string;
  name: string;
  downloadText: string;
  disabled: boolean;
  allowedFiles: IManualFileType[];
}
interface IManualFileType {
  type: string;
  minSize: number;
  maxSize: number;
  downloadFile: string;
  uploadType: string;
  headers?: string[];
}
export const ManualFileUploadTypeList: Array<IManualFileUploadType> = [
  {
    type: 'meterData',
    name: 'Meter Data',
    downloadText: 'Meter',
    disabled: false,
    allowedFiles: [
      {
        type: 'CSV',
        minSize: 36,
        maxSize: 52428800,
        downloadFile: 'PointHistoryReferenceSchema.csv',
        uploadType: 'PointHistoryData'
      }
    ]
  },
  {
    type: 'utilityBill',
    name: 'Utility Bill',
    downloadText: 'Utility',
    disabled: false,
    allowedFiles: [
      {
        type: 'CSV, URJ',
        minSize: 108,
        maxSize: 52428800,
        downloadFile: 'UtilityDataReferenceSchema.csv',
        uploadType: 'UtilityData'
      }
    ]
  }
];

export const UpdatedManualFileUploadTypeList: Array<IManualFileUploadType> = [
  {
    type: 'meterData',
    name: 'Meter Data',
    downloadText: 'Meter',
    disabled: false,
    allowedFiles: [
      {
        type: 'CSV',
        minSize: 36,
        maxSize: 1610612736,
        downloadFile: 'PointHistoryReferenceSchema.csv',
        uploadType: 'PointHistoryData',
        headers: ['SystemGUID', 'ItemName', 'Value', 'Quality', 'TimeStamp']
      },
      {
        type: 'xslx',
        minSize: 36,
        maxSize: 5242880,
        downloadFile: 'PointHistoryDataSizeReferenceSchema.xlsx',
        uploadType: 'PointHistoryData'
      }
    ]
  }
];

export interface IUpdatedTemplateFileType {
  [key: string]: {
    downloadFile: string;
    uploadType: string;
  };
}
export interface IUpdatedTemplateDownloadType {
  type: string;
  name: string;
  downloadText: string;
  disabled: boolean;
  templateFiles: IUpdatedTemplateFileType;
}

export const UpdatedTemplateDownloadList: Array<IUpdatedTemplateDownloadType> = [
  {
    type: 'meterData',
    name: 'Meter Data',
    downloadText: 'Meter',
    disabled: false,
    templateFiles: {
      PointHistoryReferenceSchema: {
        downloadFile: 'PointHistoryReferenceSchema.csv',
        uploadType: 'PointHistoryData'
      },
      PointHistoryDataSizeReferenceSchema: {
        downloadFile: 'PointHistoryDataSizeReferenceSchema.xlsx',
        uploadType: 'PointHistoryData'
      },
      PointHistoryReferenceSchemaFilled: {
        downloadFile: 'PointHistoryReferenceSchemaFilled.csv',
        uploadType: 'PointHistoryData'
      }
    }
  }
];

export const ZLOAssociationUploadSettings: IXLSXFileUploadSettings = {
  extensions: ['xlsx'],
  mimeTypes: [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ],
  minSize: 36,
  maxSize: 5242880, // in bytes: 5 MB
  downloadFile: 'SpaceEquipmentMapReferenceSchema.xlsx',
  uploadType: 'PointHistoryData'
};

export const portfolioEnergyTabs = {
  All: 'All',
  Electric: 'electric',
  Gas: 'Gas',
  Water: 'Water'
};
export const apiNoContentStatusCode: number = 204;
export const apiSuccessStatusCode: number = 200;
export const apiBadRequestStatusCode: number = 400;
export const apiConflictStatusCode: number = 409;
export const postApiSuccess: number = 201;
//In Millieseconds
export const UPLOAD_REFRESH_INTERVAL: number = 30000;
//In Seconds
export const UPLOAD_MODAL_REDIRECT_TIME: number = 10;
export const PUBLISH_MODAL_REDIRECT_TIME: number = 5;
// Show values with 2 digits after decimal
export const KPI_VALUE_DECIMAL_PRECISION: number = 2;
// Show values with 1 digits after decimal for percentage
export const KPI_PERCENTAGE_DECIMAL_PRECISION: number = 1;

export const ZERO_DEFAULT_VALUE: number = 0;

export const PERCENTAGE_HUNDRED: number = 100;

export const PERCENT_CHANGE_THRESHOLD: number =
  window && window.ENV && window.ENV.PERCENT_CHANGE_THRESHOLD
    ? window.ENV.PERCENT_CHANGE_THRESHOLD
    : 100000;

export const MULTIPLE_UPLOAD_FILES: number =
  window && window.ENV && window.ENV.MULTIPLE_UPLOAD_FILES
    ? window.ENV.MULTIPLE_UPLOAD_FILES
    : 6;
export const ElEMENT_PER_SCROLL: number =
  window && window.ENV && window.ENV.ElEMENT_PER_SCROLL
    ? window.ENV.ElEMENT_PER_SCROLL
    : 10;

export const PreferredUnit = {
  Electricity: 'kilowatt hour',
  Gas: 'million btu',
  Water: 'gallon'
};

export const POLLING_SECONDS: number = 900;
export const POLLING_MILLI_SECONDS: number = 1000;

export const MAGIC_VALUE = {
  ZERO: 0,
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
  SIX: 6,
  SEVEN: 7,
  NINE: 9,
  TEN: 10,
  ELEVEN: 11,
  TWELVE: 12,
  FIFTEEN: 15,
  SEVENTEEN: 17,
  EIGHTEEN: 18,
  TWENTYTHREE: 23,
  TWENTYFOUR: 24,
  TWENTY: 20,
  THIRTY: 30,
  THIRTYONE: 31,
  FIFTY: 50,
  FIFTYNINE: 59,
  SIXTY: 60,
  NINETYTWO: 92,
  HUNDRED: 100,
  TWOHUNDRED: 200,
  TWOHUNDREDONE: 201,
  ONEHUNDREDEIGHTY: 180,
  SIXHUND: 600,
  EIGHTFIVTY: 850,
  THOUSAND: 1000,
  THREESIXZEROZERO: 3600,
  MILLION: 1000000,
  MEGABYTES: 1048576
};
export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

export const alarmTypes = [
  {
    text: 'Electricity Consumption Threshold',
    header: 'ELECTRICITY',
    value: 'ElectricMeter',
    templateId: '891d41a0-3176-465e-9d08-9e5af231fdbc'
  },
  {
    text: 'Gas Consumption Threshold',
    header: 'GAS',
    value: 'GasMeter',
    templateId: 'c3b9a5d9-7e84-4f68-bcbc-bb9222110b5e'
  }
];

export const parseIntBase = 10;
export const fileUploadSizeDecimal = 2;

export const euiDefaultUnit = 'kBTU/sq. ft';

export const euiStatus = {
  SUCCESS: 'Processed Successfully',
  INCOMPLETE_DATA: 'Data Not Available',
  AREA_INFO_MISSING: 'Area Info Missing'
};

export const euiMessage = {
  SUCCESS: 'EUI Calculated successfully'
};

export const UtilityMessageMapping: IUrjanetMessageObjectType = {
  Initiated: descriptors.urjanetStatus.VERIFICATIONINPROGMESSAGE,
  Enroll_Initiated: descriptors.urjanetStatus.VERIFICATIONINPROGMESSAGE,
  Re_Enroll_Initiated: descriptors.urjanetStatus.REENROLLMENTTOOLTIP,
  SUBMITTED: descriptors.urjanetStatus.SUBMITTEDMSG,
  NOMINATED: descriptors.urjanetStatus.NOMINATEDMESSAGE,
  LOGIN_UPDATED: descriptors.urjanetStatus.VERIFICATIONINPROGMESSAGE,
  ATL_REVIEW: descriptors.urjanetStatus.VERIFICATIONINPROGMESSAGE,
  ENROLLMENT_EVENT: descriptors.urjanetStatus.VERIFICATIONINPROGMESSAGE,
  Credential_Update_Initiated:
    descriptors.urjanetStatus.VERIFICATIONINPROGMESSAGE,
  SUCCESSFUL_ENROLLED: descriptors.urjanetStatus.ENROLLEDMSG,
  SUCCESSFUL_DELIVERED: descriptors.urjanetStatus.SUCCESSFUL_DELIVEREDMSG,
  PRODUCTION: descriptors.urjanetStatus.PRODUCTIONMSG,
  DAQ_PRODUCTION: descriptors.urjanetStatus.ENROLLED,
  FAILED_LOGIN: descriptors.urjanetStatus.FAILEDLOGINMESSAGE,
  NEEDS_CREDENTIAL: descriptors.urjanetStatus.NEEDSCREDENTIALMSG,
  ACCOUNT_MISSING: descriptors.urjanetStatus.ACCOUNTMISSINGMESSAGE,
  STATEMENT_MISSING: descriptors.urjanetStatus.STATEMENTMISSINGMSG,
  STATEMENT_FAILED: descriptors.urjanetStatus.DATAUNAVAILABLEMESSAGE,
  SUCCESSFUL_NOT_ENROLLED: descriptors.urjanetStatus.NOTENROLLEDMESSAGE,
  BLOCKED: descriptors.urjanetStatus.BLOCKEDMESSAGE,
  INACTIVE: descriptors.urjanetStatus.INACTIVEMESSAGE,
  AGED_BILL: descriptors.urjanetStatus.FINALLEDMESSAGE,
  FINALLED: descriptors.urjanetStatus.FINALLEDMESSAGE,
  DEACTIVATED: descriptors.urjanetStatus.DEACTIVATEDMESSAGE,
  Connectivity_Err: descriptors.urjanetStatus.CONNECTIONERRORMESSAGE,
  LOGIN_FAILURE: descriptors.urjanetStatus.LOGINFAILUREMESSAGE,
  Deactivation_Initiated: descriptors.urjanetStatus.DEACTIVATIONINITIATEDMSSG,
  // TEMPLATE_FAILURE: descriptors.urjanetStatus.ERRORMESSAGE,
  Active: descriptors.urjanetStatus.ACTIVEMSG,
  MetersMismatch: descriptors.urjanetStatus.METERSMISMATCHEDMSG,
  FAILED_TO_ACCESS: descriptors.urjanetStatus.FAILEDTOACCESSMSG,
  NEEDS_TEMPLATE: descriptors.urjanetStatus.NEEDSTEMPLATEMSG,
  UNDER_REVIEW: descriptors.urjanetStatus.UNDERREVIEWMSG,
  WEBSITE_ISSUE: descriptors.urjanetStatus.WEBSITEISSUEMSG,
  CAPTCHA_LOGIN: descriptors.urjanetStatus.CAPTCHALOGINMSG,
  TEMPLATE_FAILURE: descriptors.urjanetStatus.TEMPLATEFAILUREMSG,
  NEEDS_ENROLLMENT: descriptors.urjanetStatus.NEEDSENROLLMENTMSG,
  NO_BILL: descriptors.urjanetStatus.NOBILLMSG,
  RE_ENROLLED: descriptors.urjanetStatus.REENROLLEDMSG,
  NAVIGATION_FAILURE: descriptors.urjanetStatus.NAVIGATIONFAILUREMSG,
  SOURCE_FORMAT_CHANGE: descriptors.urjanetStatus.SOURCEFORMATCHANGEMSG,
  ACCOUNT_NUMBER_CHANGE: descriptors.urjanetStatus.ACCOUNTNUMBERCHANGEMSG,
  USER_ACTION_REQUIRED: descriptors.urjanetStatus.USERACTIONREQUIREDMSG,
  MIGRATION: descriptors.urjanetStatus.MIGRATIONMSG,
  INITIAL_TEMPLATE_DEVELOPMENT:
    descriptors.urjanetStatus.INITIALTEMPLATEDEVELOPMENTMSG,
  REJECTED: descriptors.urjanetStatus.REJECTEDMSG,
  EBILL_ENROLLMENT: descriptors.urjanetStatus.EBILLENROLLMENTMSG,
  CREDENTIAL_UPDATED: descriptors.urjanetStatus.CREDENTIALUPDATEDMSG,
  TEMPLATE_UPDATED: descriptors.urjanetStatus.TEMPLATEUPDATEDMSG,
  UNKNOWN: descriptors.urjanetStatus.UNKNOWNMSG,
  PENDING: descriptors.urjanetStatus.PENDINGMSG,
  DELETED: descriptors.urjanetStatus.DELETEDMSG,
  ENROLLMENT_FAILURE: descriptors.urjanetStatus.ENROLLMENTFAILUREMSG,
  DOES_NOT_EXIST: descriptors.urjanetStatus.DOESNOTEXISTMSG,
  ACCOUNT_NUMBER_MISMATCH: descriptors.urjanetStatus.ACCOUNTNUMBERMISMATCHMSG,
  CONVERSION_IN_PROGRESS: descriptors.urjanetStatus.CONVERSIONINPROGRESSMSG,
  RE_ENROLLED_REQUIRED: descriptors.urjanetStatus.REENROLLEDREQUIREDMSG,
  // IDS Statuses
  CONNECTION_SUCCESS: descriptors.urjanetStatus.PRODUCTIONMSG,
  ENROLL_INITIATED: descriptors.urjanetStatus.VERIFICATIONINPROGMESSAGEIDS,
  CONNECTION_IN_PROGRESS:
    descriptors.urjanetStatus.VERIFICATIONINPROGMESSAGEIDS,
  VERIFICATION_INITIATED:
    descriptors.urjanetStatus.VERIFICATIONINPROGMESSAGEIDS,
  CONNECTION_FAILURE: descriptors.urjanetStatus.CONNECTIONERRORMESSAGEIDS,
  DATA_ACCESS_FAILURE: descriptors.urjanetStatus.FAILEDTOACCESSMSGIDS,
  REACTIVATION_INITIATED: descriptors.urjanetStatus.REACTIVATIONTOOLTIP,
  DEACTIVATION_INITIATED: descriptors.urjanetStatus.DEACTIVATIONINITIATEDMSSG,
  INTERVALS_NOT_SUPPORTED: descriptors.urjanetStatus.INTERVALSNOTSUPPORTEDMSG,
  NEW_ACCOUNT: descriptors.urjanetStatus.PLUGNEWACCOUNTMSG
};
export const UtilityStatusMessageKey: IUrjanetMessageObjectType = {
  Initiated: descriptors.urjanetStatus.VERIFICATIONINPROG,
  Enroll_Initiated: descriptors.urjanetStatus.VERIFICATIONINPROG,
  Re_Enroll_Initiated: descriptors.urjanetStatus.REENROLLMENTPROG,
  SUBMITTED: descriptors.urjanetStatus.SUBMITTED,
  NOMINATED: descriptors.urjanetStatus.NOMINATEDPROG,
  MetersMismatch: descriptors.urjanetStatus.METERSMISMATCHED,
  LOGIN_UPDATED: descriptors.urjanetStatus.VERIFICATIONINPROG,
  ATL_REVIEW: descriptors.urjanetStatus.VERIFICATIONINPROG,
  ENROLLMENT_EVENT: descriptors.urjanetStatus.VERIFICATIONINPROG,
  Deactivation_Initiated: descriptors.urjanetStatus.DEACTIVATIONINITIATED,
  Credential_Update_Initiated: descriptors.urjanetStatus.VERIFICATIONINPROG,
  SUCCESSFUL_ENROLLED: descriptors.urjanetStatus.ENROLLED,
  PRODUCTION: descriptors.urjanetStatus.PRODUCTION,
  DAQ_PRODUCTION: descriptors.urjanetStatus.ENROLLED,
  SUCCESSFUL_DELIVERED: descriptors.urjanetStatus.SUCCESSFUL_DELIVERED,
  FAILED_LOGIN: descriptors.urjanetStatus.FAILEDLOGIN,
  NEEDS_CREDENTIAL: descriptors.urjanetStatus.NEEDSCREDENTIAL,
  ACCOUNT_MISSING: descriptors.urjanetStatus.ACCOUNTMISSING,
  STATEMENT_MISSING: descriptors.urjanetStatus.STATEMENTMISSING,
  STATEMENT_FAILED: descriptors.urjanetStatus.DATAUNAVAILABLE,
  AGED_BILL: descriptors.urjanetStatus.DATAUNAVAILABLE,
  SUCCESSFUL_NOT_ENROLLED: descriptors.urjanetStatus.NOTENROLLED,
  BLOCKED: descriptors.urjanetStatus.BLOCKED,
  INACTIVE: descriptors.urjanetStatus.INACTIVE,
  FINALLED: descriptors.urjanetStatus.FINALLED,
  DEACTIVATED: descriptors.urjanetStatus.DEACTIVATED,
  Connectivity_Err: descriptors.urjanetStatus.CONNECTIONERROR,
  LOGIN_FAILURE: descriptors.urjanetStatus.LOGINFAILURE,
  Active: descriptors.urjanetStatus.Active,
  Enroll_Successful: descriptors.urjanetStatus.Enroll_Successful,
  FAILED_TO_ACCESS: descriptors.urjanetStatus.FAILEDTOACCESS,
  NEEDS_TEMPLATE: descriptors.urjanetStatus.NEEDSTEMPLATE,
  UNDER_REVIEW: descriptors.urjanetStatus.UNDERREVIEW,
  WEBSITE_ISSUE: descriptors.urjanetStatus.WEBSITEISSUE,
  CAPTCHA_LOGIN: descriptors.urjanetStatus.CAPTCHALOGIN,
  TEMPLATE_FAILURE: descriptors.urjanetStatus.TEMPLATEFAILURE,
  NEEDS_ENROLLMENT: descriptors.urjanetStatus.NEEDSENROLLMENT,
  NO_BILL: descriptors.urjanetStatus.NOBILL,
  RE_ENROLLED: descriptors.urjanetStatus.REENROLLED,
  NAVIGATION_FAILURE: descriptors.urjanetStatus.NAVIGATIONFAILURE,
  SOURCE_FORMAT_CHANGE: descriptors.urjanetStatus.SOURCEFORMATCHANGE,
  ACCOUNT_NUMBER_CHANGE: descriptors.urjanetStatus.ACCOUNTNUMBERCHANGE,
  USER_ACTION_REQUIRED: descriptors.urjanetStatus.USERACTIONREQUIRED,
  MIGRATION: descriptors.urjanetStatus.MIGRATION,
  INITIAL_TEMPLATE_DEVELOPMENT:
    descriptors.urjanetStatus.INITIALTEMPLATEDEVELOPMENT,
  REJECTED: descriptors.urjanetStatus.REJECTED,
  EBILL_ENROLLMENT: descriptors.urjanetStatus.EBILLENROLLMENT,
  CREDENTIAL_UPDATED: descriptors.urjanetStatus.CREDENTIALUPDATED,
  TEMPLATE_UPDATED: descriptors.urjanetStatus.TEMPLATEUPDATED,
  UNKNOWN: descriptors.urjanetStatus.UNKNOWN,
  PENDING: descriptors.urjanetStatus.PENDING,
  DELETED: descriptors.urjanetStatus.DELETED,
  ENROLLMENT_FAILURE: descriptors.urjanetStatus.ENROLLMENTFAILURE,
  DOES_NOT_EXIST: descriptors.urjanetStatus.DOESNOTEXIST,
  ACCOUNT_NUMBER_MISMATCH: descriptors.urjanetStatus.ACCOUNTNUMBERMISMATCH,
  CONVERSION_IN_PROGRESS: descriptors.urjanetStatus.CONVERSIONINPROGRESS,
  RE_ENROLLED_REQUIRED: descriptors.urjanetStatus.REENROLLEDREQUIRED,
  // IDS Statuses
  CONNECTION_SUCCESS: descriptors.urjanetStatus.PRODUCTION,
  ENROLL_INITIATED: descriptors.urjanetStatus.VERIFICATIONINPROGIDS,
  CONNECTION_IN_PROGRESS: descriptors.urjanetStatus.VERIFICATIONINPROGIDS,
  VERIFICATION_INITIATED: descriptors.urjanetStatus.VERIFICATIONINPROG,
  CONNECTION_FAILURE: descriptors.urjanetStatus.CONNECTIONERROR,
  DATA_ACCESS_FAILURE: descriptors.urjanetStatus.FAILEDTOACCESS,
  REACTIVATION_INITIATED: descriptors.urjanetStatus.REACTIVATIONPROG,
  DEACTIVATION_INITIATED: descriptors.urjanetStatus.DEACTIVATIONINITIATED,
  INTERVALS_NOT_SUPPORTED: descriptors.urjanetStatus.INTERVALSNOTSUPPORTED,
  NEW_ACCOUNT: descriptors.urjanetStatus.ENROLLED
};

export const PlugMessageMappingWithDetail: {
  [key: string]: IUrjanetMessageObjectType;
} = {
  CONNECTION_SUCCESS: { default: descriptors.urjanetStatus.PRODUCTIONMSG },
  ENROLL_INITIATED: {
    default: descriptors.urjanetStatus.VERIFICATIONINPROGMESSAGEIDS
  },
  CONNECTION_IN_PROGRESS: {
    default: descriptors.urjanetStatus.VERIFICATIONINPROGMESSAGEIDS,
    EMAIL_APPROVAL: descriptors.urjanetStatus.PLUGEMAILAPPROVALMSG
  },
  VERIFICATION_INITIATED: {
    default: descriptors.urjanetStatus.VERIFICATIONINPROGMESSAGEIDS
  },
  CONNECTION_FAILURE: {
    default: descriptors.urjanetStatus.CONNECTIONERRORMESSAGEIDS,
    INVALID_CREDENTIALS: descriptors.urjanetStatus.PLUGINVALIDCREDENTIALSMSG,
    USER_REVOKED_ACCESS: descriptors.urjanetStatus.PLUGINVALIDCREDENTIALSMSG
  },
  DATA_ACCESS_FAILURE: {
    default: descriptors.urjanetStatus.FAILEDTOACCESSMSGIDS,
    CREDENTIAL_ISSUE: descriptors.urjanetStatus.PLUGCREDENTIALISSUEMSG,
    NO_DATA_AVAILABLE: descriptors.urjanetStatus.PLUGNODATAAVAILABLEMSG,
    UNSUCCESSFUL_EMAIL_APPROVAL:
      descriptors.urjanetStatus.PLUGUNSUCCESSFULEMAILAPPROVALMSG,
    USER_REVOKED_ACCESS: descriptors.urjanetStatus.PLUGCREDENTIALISSUEMSG
  },
  REACTIVATION_INITIATED: {
    default: descriptors.urjanetStatus.REACTIVATIONTOOLTIP
  },
  DEACTIVATION_INITIATED: {
    default: descriptors.urjanetStatus.DEACTIVATIONINITIATEDMSSG
  },
  INTERVALS_NOT_SUPPORTED: {
    default: descriptors.urjanetStatus.INTERVALSNOTSUPPORTEDMSG
  },
  NEW_ACCOUNT: { default: descriptors.urjanetStatus.PLUGNEWACCOUNTMSG }
};

export const ElectricUnit = 'electric';
export const GasUnit = 'gas';
export const WaterUnit = 'water';
// 2 hours
export const HourlyTickInterval = 7200000;
// 30 days
export const DailyTickInterval = 2592000000;
// 1 days
export const singleDayTickInterval = 86400000;
// percentage width of fixed grey area for all progress bar
export const PROGRESS_GREY_PERCENTAGE = 7;

export const YAXISCONSUMPTIONMIN = 0;

export const Value = 'Value';
export const SiteName = 'SiteName';
export const Deviation = 'Deviation';
export const TotalActualCost = 'TotalActualCost';
export const ConsumptionHigh = 'ConsumptionHigh';
export const ConsumptionTypeName = 'ConsumptionTypeName';
export const ConsumptionDeviation = 'ConsumptionDeviation';
export const EnergyViewDetailsAllUtilitiesFields = {
  sites: 'name',
  actualConsup: 'totalConsumption',
  BaselineConsup: 'totalBaselineConsumption',
  previousPeriodConsumption: 'totalpreviousPeriodConsumption',
  consupDeviation: 'totalEnergyDeviation',
  changePercent: 'totalEnergyDeviationPercentage',
  euiCurrent: 'actualEui',
  euiPrevPeriod: 'baselineEui',
  EuiChange: 'euiDeviation',
  EuiChangePercentage: 'euiDeviationPercentage',
  displayUnit: 'displayUnit',
  absoluteTotalBaselineConsumption: 'absoluteTotalBaselineConsumption',
  absoluteTotalConsumption: 'absoluteTotalConsumption'
};

export const UTILITY_TABS = {
  ZERO: 0,
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4
};
export const HOUR_MOMENT_VALUE = 3600000;
export const DAILY_MOMENT_VALUE = 86400000;
export const DAILY_HOURS = 24;
// minimum character required for urjanet search
export const MINIMUM_SEARCH_CHARACTER = 3;

export const TEN_PERCENT_OF = 0.1;

export const IntervalType = {
  Hourly: 'hourly',
  Daily: 'daily',
  Monthly: 'monthly'
};

export const maxDaysInYear = 366;
export const maxDaysInMonth = 31;
export enum UtilityCostType {
  portfolio,
  site
}

export const specialChars = /[`!#$%^&*()_+\-=\[\]{};':"\\|,<>\/?~]/;
export const specialCharsAutomaticAcc = /[`!#$%^&*()+\=\[\]{};':"\\|,<>\/?~]/;

export const StackedColumnConstants = {
  actualColumnWidth: 16,
  actualOpacity: 0.8,
  previousColumnWidth: 8,
  previousOpacity: 0.5,
  numberOfGridLines: 5,
  stackBorder: 2,
  groupPadding: 0.39
};

export const StackedCarbonScopeOneSubUtilities = {
  KEROZENE: 'Kerosene',
  GAS: 'Gas'
};

export const FuelColorMappingFor6 = [
  '#9B59B6',
  '#7EB338',
  '#FFC627',
  '#FF7929',
  '#EE3124',
  '#1792E5'
];
export const FuelColorMapping = [
  '#B98BCC',
  '#A4C974',
  '#FFD768',
  '#F69B64',
  '#F36E65',
  '#10659F',
  '#B9271C',
  '#A94E17',
  '#B2BA1B',
  '#577C27',
  '#6C3E7F'
];

export const colorsAvailableForFuels = FuelColorMapping.length;
export const maxScope1MonthLimit = 24;

export const maxScopeOneQuantityAllowed = 99999;

export const LINE_CHART = 'Line';

export const STACKED_BAR_CHART = 'stacked column';

export const largeFileChunkSize = 1048576 * 3;
